import {debounce} from 'lodash';
import {useRouter} from 'next/router';
import {useTranslation} from 'next-i18next';
import {useEffect, useRef, useState} from 'react';

import {SEARCH_FILTERS} from '@/src/app/constants/search';
import FilterRow from '@/src/Search/components/FilterRow';
import {useSearchFilters} from '@/src/Search/utils/useSearchFilters';
import TextLocal from '@/src/textLocal/containers/TextLocal';
import {SimpleCollapse, Text} from '@/src/ui';
import SimpleInput from '@/src/ui/input/components/SimpleInput';

import css from '../styles/VacancySalaryRange.module.css';

const DEBOUNCE_DELAY = 600;
const MIN_VALUE = 1;

const VacancySalaryRange = () => {
  const {t} = useTranslation('common');
  const {query, isReady} = useRouter();
  const {setQueryFilters} = useSearchFilters();
  const [isError, setIsError] = useState(false);
  const minSalaryRef = useRef();
  const maxSalaryRef = useRef();

  const handleMinSalaryChange = debounce((event) => {
    if (
      String(event.target.value).length &&
      // @ts-ignore
      String(maxSalaryRef?.current?.value).length &&
      // @ts-ignore
      Number(event.target.value) >= Number(maxSalaryRef?.current?.value)
    ) {
      setIsError(true);
    } else {
      setIsError(false);
      handleUpdateQuery(
        // @ts-ignore
        minSalaryRef?.current?.value,
        // @ts-ignore
        maxSalaryRef?.current?.value
      );
    }
  }, DEBOUNCE_DELAY);

  const handleMaxSalaryChange = debounce((event) => {
    if (
      String(event.target.value).length &&
      // @ts-ignore
      String(minSalaryRef?.current?.value).length &&
      // @ts-ignore
      Number(event.target.value) <= Number(minSalaryRef?.current?.value)
    ) {
      setIsError(true);
    } else {
      setIsError(false);
      handleUpdateQuery(
        // @ts-ignore
        minSalaryRef?.current?.value,
        // @ts-ignore
        maxSalaryRef?.current?.value
      );
    }
  }, DEBOUNCE_DELAY);

  const handleUpdateQuery = debounce((minSalary, maxSalary) => {
    setQueryFilters({
      ...query,
      [SEARCH_FILTERS.SALARY_MIN]: minSalary,
      [SEARCH_FILTERS.SALARY_MAX]: maxSalary,
    });
  }, DEBOUNCE_DELAY);

  useEffect(() => {
    if (
      isReady &&
      !query[SEARCH_FILTERS.SALARY_MAX] &&
      !query[SEARCH_FILTERS.SALARY_MIN]
    ) {
      // @ts-ignore
      minSalaryRef.current.value = '';
      // @ts-ignore
      maxSalaryRef.current.value = '';
    }
  }, [query[SEARCH_FILTERS.SALARY_MAX], query[SEARCH_FILTERS.SALARY_MIN]]);

  return (
    <SimpleCollapse
      defaultIsOpen
      headTitle={
        <Text
          fontSize={Text.FONT_SIZE.SIZE_16}
          fontWeight={Text.FONT_WEIGHT.MEDIUM}
        >
          <TextLocal id={'job-portal.annually-salary'} />
        </Text>
      }
    >
      <FilterRow>
        <div className={css.inputs}>
          <div>
            {/*@ts-ignore*/}
            <SimpleInput
              isRedBorder={isError}
              defaultValue={`${query[SEARCH_FILTERS.SALARY_MIN]}`}
              inputRef={minSalaryRef}
              type={'number'}
              placeholder={t('job-portal.min')}
              width={SimpleInput.WIDTH.WIDTH_FULL}
              onChange={handleMinSalaryChange}
              min={MIN_VALUE}
            />
          </div>{' '}
          -
          <div>
            {/*@ts-ignore*/}
            <SimpleInput
              isRedBorder={isError}
              inputRef={maxSalaryRef}
              type={'number'}
              placeholder={t('job-portal.max')}
              width={SimpleInput.WIDTH.WIDTH_FULL}
              defaultValue={`${query[SEARCH_FILTERS.SALARY_MAX]}`}
              onChange={handleMaxSalaryChange}
              min={MIN_VALUE}
            />
          </div>
        </div>
      </FilterRow>
    </SimpleCollapse>
  );
};

export default VacancySalaryRange;
